import { useEffect, useState, useMemo } from "react";
import config from "../../constants/config.js";

function MigrationWidget({
    shops,
    onCancel,
    onClose,
    onStartMigration
}) {
    const steps = [
        "migration-settings",
        "migration-product-select"
    ];

    const [ fromStore, setFromStore ] = useState( "" );
    const [ toStore, setToStore ] = useState( "" );
    const [ currentShopForProducts , setCurrentShopForProducts ] = useState( "" );

    const [ overwriteProducts , setOverwriteProducts ] = useState( true );
    const [ currentStep , setCurrentStep ] = useState( steps[0] );
    const [ loadingProducts , setLoadingProducts ] = useState( false );
    const [ productsForShop , setProductsForShop ] = useState( [] );
    const [ searchTerm, setSearchTerm ] = useState( "" );
    const [ selectedHandles, setSelectedHandles ] = useState( [] );
    const [ allSelectedGlobal, setAllSelectedGlobal ] = useState( false );
    const [ disablePerma , setDisablePerma ] = useState( false );

    useEffect( () => {
        async function reInitProducts() {
            setCurrentShopForProducts( fromStore );
            setLoadingProducts( true );
            setProductsForShop([]);

            const _products = await getProducts( fromStore );
            if ( _products.length > 0 ) {
                setProductsForShop( _products );
            }

            setLoadingProducts( false );
        } 


        // are we step 2
        // is currentShopForProducts the same as the fromStore
        // if yes, it means no changes occured and we dont need to init products
        // if no, it means we need to init products

        if ( currentStep == steps[1] ) {
            if ( currentShopForProducts == fromStore ) {

            } else {
                reInitProducts();
            }
        }

    } , [ currentStep ] );

    const filteredProducts = useMemo( () => {
        return productsForShop.filter(( p ) => {
            if ( searchTerm.trim() == "" ) {
                return true;
            }
            
            return (
                p.title.toLowerCase().includes( searchTerm.toLowerCase() ) ||
                p.product_id.includes( searchTerm.toLowerCase() ) ||
                p.product_graphql_id.includes( searchTerm.toLowerCase() ) ||
                p.handle.includes( searchTerm.toLowerCase() ) 
            );
        });
    }, [ searchTerm, productsForShop ] );

    function handleCheckboxChange( handle ) {
        setSelectedHandles( ( prev ) => {
            if ( prev.includes( handle ) ) {
                return prev.filter( ( h ) => h !== handle );
            } else {
                return [...prev, handle];
            }
        });

        setAllSelectedGlobal( false );
    }

    function handleSelectAllGlobal() {
        if ( allSelectedGlobal ) {
            setSelectedHandles([]);
            setAllSelectedGlobal(false);
        } else {
            setSelectedHandles( [] );
            setAllSelectedGlobal( true );
        }
    }

    function updateOverwriteProducts() {
        setOverwriteProducts( !overwriteProducts );
    }

    function resetAll() {
        setFromStore( "" );
        setToStore( "" );
        setOverwriteProducts( true );
    }

    function goToNextStep( ) {
        setCurrentStep( steps[1] );
    }

    function goToPreviousStep( ) {
        setCurrentStep( steps[0] );
    }

    async function submitMigration() {
        setDisablePerma( true );

        try {
            const requestBody = {
                products: [],
                overwriteProducts: overwriteProducts,
                fromShop: fromStore,
                toShop: toStore,
            };

            if ( allSelectedGlobal ) {
                requestBody.products = [ "*" ];
            } else {
                requestBody.products = selectedHandles;
            }

            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/migrations`;
            const requestSettings = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( requestBody )
            };
            const response = await fetch( url , requestSettings );
            if ( response.ok ) {
                onStartMigration( true );
            }
        } catch ( error ) {
            console.log( error );
            onStartMigration( false );
        }
        
        return;
    }

    async function getProducts( shop ) {
        let products = [];

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/products/find/${encodeURIComponent(shop)}`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };

            const response = await fetch( url , requestSettings );
            const data = await response.json();
            if ( data?.length > 0 ) {
                products = data;
            }
        } catch ( error ) {
            console.log( error );
        }

        return products;
    }

    return(
        <div className="modal-overlay migration-modal" onClick={onClose}>
            <div className="modal-content extra-wide" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>
                    <span>×</span>
                    <span className="sr-only">Close modal</span>
                </button>

                { currentStep == steps[0] &&
                    <div className={`step-${steps[0]}`}>
                        <div className="modal-body">
                            <h1>Step 1: Choose Migration Settings</h1>
                            <p>
                                Start by providing the details for your product migration. Select the source store (where products will be copied from) and the destination store (where products will be migrated to). Make sure the "to store" is different from the "from store." You can also choose whether existing products in the destination store should be overwritten.
                            </p>

                            <div className="form-group from-store-wrapper">
                                <label htmlFor="from-store">From Store: </label>
                                <select
                                    id="from-store"
                                    value={fromStore}
                                    onChange={ ( e ) => {
                                        setFromStore( e.target.value );
                                        if ( e.target.value === toStore ) {
                                            setToStore( "" );
                                        }
                                    }}
                                >
                                    <option disabled value="">-- Choose a store --</option>
                                    {shops.map((shop) => (
                                        <option key={shop.id} value={shop.shop}>
                                            {shop.nickname}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group to-store-wrapper">
                                <label htmlFor="to-store">To Store: </label>
                                <select
                                    id="to-store"
                                    value={toStore}
                                    onChange={ ( e ) => {
                                        setToStore( e.target.value );
                                        if ( e.target.value === fromStore ) {
                                            setFromStore( "" );
                                        }
                                    }}
                                >
                                    <option disabled value="">-- Choose a store --</option>
                                    {shops.map((shop) => (
                                        <option key={shop.id} value={shop.shop}>
                                            {shop.nickname}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className="form-group checkbox">
                                <label htmlFor="overwrite-products">Overwrite Products?</label>
                                <input onChange={ updateOverwriteProducts } checked={overwriteProducts} id="overwrite-products" type="checkbox" />
                            </div>
                        </div>

                        <div className="modal-actions">
                            <button onClick={onCancel}>Cancel</button>
                            <button onClick={resetAll}>Reset</button>
                            <button onClick={goToNextStep} disabled={ fromStore == "" || toStore == ""}>Continue</button>
                        </div>
                    </div>
                } 

                { currentStep == steps[1] &&
                    <div className={`step-${steps[1]}`}>
                        <div className="modal-body">
                            <h1>Step 2: Choose Products</h1>
                        </div>

                        { loadingProducts && 
                            <div className="skeleton-wrapper">
                                <div className="product-row-custom skeleton">
                                    <div className="skeleton-text long" />
                                </div>

                                {[...Array(6)].map((_, i) => (
                                    <div key={i} className="product-row skeleton">
                                        <div className="skeleton-checkbox" />
                                        <div className="skeleton-text short" />
                                        <div className="skeleton-text long" />
                                    </div>
                                ))}
                            </div>
                        }

                        { !loadingProducts && productsForShop.length > 0 &&
                            <div className="product-list">
                                <input
                                    type="text"
                                    placeholder="Search products..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm( e.target.value )}
                                    className="search-input"
                                />

                                <div className="select-all-row">
                                    <input
                                        type="checkbox"
                                        checked={allSelectedGlobal}
                                        onChange={handleSelectAllGlobal}
                                    />
                                    <span className="select-all-label">Select All Products in Shop</span>
                                </div>

                                <div className="product-scroll">
                                    {filteredProducts.map( ( product ) => (
                                        <label htmlFor={`product-${fromStore}-${product.id}`} key={product.id} className="product-row">
                                            <input
                                                id={`product-${fromStore}-${product.id}`}
                                                type="checkbox"
                                                checked={
                                                    allSelectedGlobal || selectedHandles.includes(product.handle)
                                                }
                                                onChange={() => handleCheckboxChange(product.handle)}
                                                disabled={allSelectedGlobal}
                                            />
                                            <span className="product-title">{product.title}</span>
                                            <span className="product-handle"> ({product.handle})</span>
                                        </label>
                                    ))}

                                    {filteredProducts.length === 0 && (
                                        <div className="empty-message">No products found.</div>
                                    )}
                                </div>
                                

                                
                            </div>
                        }

                        { !loadingProducts && productsForShop.length <= 0 &&
                            <div>No products found</div>
                        }

                        <div className="modal-actions">
                            <button onClick={onCancel} disabled={disablePerma}>Cancel</button>
                            <button onClick={goToPreviousStep} disabled={disablePerma}>Back</button>
                            <button onClick={submitMigration} disabled={ (allSelectedGlobal ? false : selectedHandles.length <= 0) || disablePerma }>
                                { disablePerma ?
                                    <span className="icon">
                                        <svg width="15" height="15" viewBox="0 0 50 50" className="spinner">
                                            <circle cx="25" cy="25" r="20" stroke="white" strokeWidth="5" fill="none" strokeDasharray="90 150" strokeLinecap="round">
                                                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                                            </circle>
                                        </svg>
                                    </span> 
                                : 
                                    "Continue"
                                }
                            </button>
                        </div>
                    </div>
                }

                
            </div>
        </div>
    )
}

export default MigrationWidget;